const colorPrimary = '#526a99';
const colorSecondary = '#384042';
const colorBgContainer = '#fff';
const borderRadius = 2;

const theme = {
  ant: {
    token: {
      borderRadius,
      colorBgContainer,
      colorPrimary,
      colorInfo: colorPrimary,
      controlHeight: 34,
    },
    components: {
      Layout: {
        headerBg: colorBgContainer,
      },
      Button: {
        primaryShadow: 'none',
        dangerShadow: 'none',
        defaultShadow: 'none',
      },
      Table: {
        fontWeightStrong: 500,
      },
      Typography: {
        fontWeightStrong: 500,
      },
    },
  },

  styled: {
    colorPrimary,
    colorSecondary,
    colorBgContainer,
    borderRadius,
  },
};

export default theme;
